import { ChevronRight, Translate } from '@/components/icons'
import i18n from '@/i18n'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

function LanguagesAccordion() {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  const changeLanguage = (newLanguage: string) => {
    i18n.changeLanguage(newLanguage)
    localStorage.setItem('languagePreference', newLanguage)
  }

  return (
    <div className="">
      <button
        onClick={toggleAccordion}
        className="w-full text-navy-900 flex gap-x-4 py-4 items-center hover:cursor-pointer hover:bg-slate-100 pl-4 pr-2 cursor-pointer"
      >
        <Translate />
        <span className="flex-1 text-sm font-semibold text-left">{t('user.changeLang')}</span>
        <ChevronRight className={`h-6 w-6 transform transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`} />
      </button>
      <div
        style={{
          maxHeight: isOpen ? '500px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out',
        }}
      >
        <button
          onClick={() => changeLanguage('en')}
          className="text-navy-900 flex flex-col gap-x-4 py-4 hover:cursor-pointer hover:bg-slate-100 pl-4 pr-2 w-full"
        >
          {t('user.english')}
        </button>

        <button
          onClick={() => changeLanguage('es')}
          className="text-navy-900 flex flex-col gap-x-4 py-4 hover:cursor-pointer hover:bg-slate-100 pl-4 pr-2 w-full"
        >
          {t('user.spanish')}
        </button>
        <button
          onClick={() => changeLanguage('zh_hans')}
          className="text-navy-900 flex flex-col gap-x-4 py-4 hover:cursor-pointer hover:bg-slate-100 pl-4 pr-2 w-full"
        >
          {t('user.chineseSimplified')}
        </button>
        <button
          onClick={() => changeLanguage('vi')}
          className="text-navy-900 flex flex-col gap-x-4 py-4 hover:cursor-pointer hover:bg-slate-100 pl-4 pr-2 w-full"
        >
          {t('user.vietnamese')}
        </button>
        <button
          onClick={() => changeLanguage('zh_TW')}
          className="text-navy-900 flex flex-col gap-x-4 py-4 hover:cursor-pointer hover:bg-slate-100 pl-4 pr-2 w-full"
        >
          {t('user.chineseTraditional')}
        </button>

        <button
          onClick={() => changeLanguage('my')}
          className="text-navy-900 flex flex-col gap-x-4 py-4 hover:cursor-pointer hover:bg-slate-100 pl-4 pr-2 w-full"
        >
          {t('user.malay')}
        </button>
      </div>
    </div>
  )
}

export default LanguagesAccordion
